import React from 'react';
import CloudinaryVideoPlayer from '../Stand-alone/CloudinaryPlayer';
import Spread from '../spread';
import { Accordion } from 'react-bootstrap';

import BottomImageTwo from '../bottomImageTwo';
import { bottomImgWLMeds } from '../../assets/imageLibrary2';

const ServiceBody = ({ data, faqs, showSectionNav = false }) => {
  const weightLossMeds = [
    'pmj8BBmv1L',
    'dDZLlErdEF',
    'o8NlDExkLo',
    'CQ6HLzXB76',
  ];
  const microdosingMeds = [
    'microdosing-semaglutide',
    'microdosing-tirzepatide',
  ];
  const isMicrodosing = microdosingMeds.includes(data?.objectId);
  const ctaPath = isMicrodosing
    ? '/diagnosis/weight-loss?diseaseID=WOfo5j3mwb'
    : weightLossMeds.includes(data?.objectId)
    ? `/diagnosis/weight-loss?diseaseID=${data?.objectId}`
    : `/diagnosis?diseaseID=${data?.objectId}`;
  return (
    <div>
      {showSectionNav && data?.content?.sections?.length > 0 && (
        <nav
          aria-label={`${data.title} sections`}
          className=' tw-top-3 tw-z-10 tw-mx-auto tw-my-12 tw-flex tw-w-max tw-max-w-[92%] tw-gap-2 tw-overflow-x-auto tw-rounded-full tw-bg-[#F0F0F0] tw-p-2 tw-pr-8 tw-backdrop-blur-[50px] [&::-webkit-scrollbar]:tw-hidden'
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
        >
          {data.content.sections.map((section, index) => (
            <a
              key={section.title || section.heading}
              href={`#${index + 2}`}
              className={`tw-whitespace-nowrap tw-rounded-full tw-px-4 tw-py-3 tw-text-sm tw-font-medium tw-no-underline ${
                index === 0
                  ? 'tw-bg-[#1e1e1e] tw-text-white'
                  : 'tw-text-[#5f5f5f] hover:tw-bg-white hover:tw-text-[#1e1e1e]'
              }`}
            >
              {index + 1}. {section.title || section.heading}
            </a>
          ))}
        </nav>
      )}{' '}
      <div className='detailsWrapper'>
        {data?.video_main && (
          <div className='spreadWrapper'>
            <div className='theHeadingSection'>
              <h2 className='theSpreadHeading !tw-font-semibold'>
                {data?.video_main?.title ? (
                  (() => {
                    const words = data.video_main.title.trim().split(' ');
                    const normal = words.slice(0, -2).join(' ');
                    const gradient = words.slice(-2).join(' ');
                    return (
                      <>
                        {normal}
                        {normal ? ' ' : ''}
                        <span className='gradientText'>{gradient}</span>
                      </>
                    );
                  })()
                ) : (
                  <>
                    Watch how it <br className=' tw-hidden lg:tw-block' />{' '}
                    <span className='gradientText'>works</span> for you
                  </>
                )}
              </h2>
            </div>
            <div className='theSpreadContent'>
              {data?.video_main?.public_id && (
                <div className='  tw-max-w-[1440px] tw-mx-auto '>
                  <CloudinaryVideoPlayer
                    publicId={data?.video_main?.public_id}
                    caption={`Learn about ${data?.video_main?.title}`}
                  />
                </div>
              )}
            </div>
          </div>
        )}

        {data?.content?.sections.map((section, index) => {
          return (
            <div id={index + 2} key={index}>
              <Spread
                title={data?.title}
                heading={section.heading}
                text={section.content}
                path={ctaPath}
              />
            </div>
          );
        })}
        {faqs !== undefined && faqs.length > 0 ? (
          <div className='spreadWrapper'>
            <div className='theHeadingSection'>
              <h2 className='theSpreadHeading'>
                Common questions about{' '}
                <span className='gradientText'> {data?.title}</span>
              </h2>
            </div>

            <div className='theSpreadContent'>
              {' '}
              <Accordion flush className='theAccordion'>
                {data?.content?.faqs.map((item, index) => (
                  <Accordion.Item key={index} eventKey={index}>
                    <Accordion.Header>{item.title}</Accordion.Header>
                    <Accordion.Body>{item.content}</Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </div>
          </div>
        ) : null}
      </div>
      {/* <Steps />
      <Ribbon /> */}
      <BottomImageTwo
        overlayImage={false}
        path={ctaPath}
        imgSrc={
          weightLossMeds.includes(data?.objectId) || isMicrodosing
            ? bottomImgWLMeds
            : undefined
        }
        title={
          isMicrodosing ? (
            <>
              Ready to start — at a pace
              <br className='tw-hidden md:tw-block' /> that actually sticks?
            </>
          ) : weightLossMeds.includes(data?.objectId) ? (
            <>
              {' '}
              Ready to start losing
              <br className='tw-hidden md:tw-block' /> weight — without the{' '}
              <br className='tw-hidden md:tw-block' />
              needle?
            </>
          ) : undefined
        }
        showGoals={weightLossMeds.includes(data?.objectId) ? false : true}
        btnText={
          isMicrodosing
            ? 'See if I qualify'
            : weightLossMeds.includes(data?.objectId)
            ? 'Start Medical Assessment'
            : undefined
        }
      />
    </div>
  );
};

export default ServiceBody;
